export default "__VITE_PUBLIC_ASSET__473f88f0__"